<!--
//================================================================================
// ID:BC015
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC015
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/09/02 | 富士通株式会社         | 新規作成
// 01.01.00 | 2023/09/27 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main">
		<error-message />
		<h2 class="contents__h2">検索条件</h2>
		<section>
			<table class="contents__table--ichiran ichiran">
				<tbody>
					<tr class="contents__input--tr">
						<th  class="contents__input--title">
							利用者
						</th>
						<td class="contents__input--label">
							氏：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmName1"
								:maxLength="15"
								:textType="TEXTINPUT_TYPE.FULL"
								:name="'氏'"
								:groupId="'nmName'"
								:placeholder="'（フリーワード）'"
								@update:modelValue="form.nmName1 = $event"
								ref="nmName1"
								tabindex="1" />
							名：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmName2"
								:maxLength="15"
								:textType="TEXTINPUT_TYPE.FULL"
								:name="'名'"
								:groupId="'nmName'"
								:placeholder="'（フリーワード）'"
								@update:modelValue="form.nmName2 = $event"
								ref="nmName2"
								tabindex="2" />
							<itemerror-message :groupId="'nmName'"/>
						</td>
						<th  class="contents__input--title">
							生年月日
						</th>
						<td class="contents__input--label">
							<list-box
								class="contents__input--select width-auto"
								:modelValue="form.yrBirthday"
								:name="'生年月日（年）'"
								:listItems="disp.yearItems"
								:blankFlg="false"
								:groupId="'birthday'"
								@update:modelValue="form.yrBirthday = $event"
								ref="dateYear"
								:tabindex="9"
							/>
							年&nbsp;
							<list-box
								class="contents__input--select width-auto"
								:modelValue="form.mtBirthday"
								:name="'生年月日（月）'"
								:listItems="disp.monthItems"
								:blankFlg="false"
								:groupId="'birthday'"
								@update:modelValue="form.mtBirthday = $event"
								ref="dateMonth"
								:tabindex="10"
							/>
							月&nbsp;
							<list-box
								class="contents__input--select width-auto"
								:modelValue="form.dyBirthday"
								:name="'生年月日（日）'"
								:listItems="disp.dayItems"
								:blankFlg="false"
								:groupId="'birthday'"
								@update:modelValue="form.dyBirthday = $event"
								ref="dateDay"
								:tabindex="11"
							/>
							日&nbsp;
							<itemerror-message :groupId="'birthday'"/>
						</td>
					</tr>
					<tr>
						<th  class="contents__input--title">
								フリガナ
						</th>
						<td  class="contents__input--label">
							氏：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmKana1"
								:maxLength="30"
								:textType="TEXTINPUT_TYPE.HALF_KANA"
								:name="'フリガナ（氏）'"
								:groupId="'huriganaInfo'"
								:placeholder="'(ﾌﾘｰﾜｰﾄﾞ)'"
								@update:modelValue="form.nmKana1 = $event"
								ref="nmKana1"
								tabindex="3" />
							名：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmKana2"
								:maxLength="30"
								:textType="TEXTINPUT_TYPE.HALF_KANA"
								:name="'フリガナ（名）'"
								:groupId="'huriganaInfo'"
								:placeholder="'(ﾌﾘｰﾜｰﾄﾞ)'"
								@update:modelValue="form.nmKana2 = $event"
								ref="nmKana2"
								tabindex="4" />
							<itemerror-message :groupId="'huriganaInfo'"/>
						</td>
						<th  class="contents__input--title">
							郵便番号
						</th>
						<td  class="contents__input--label">
							<number-input
								class="contents__input--text width-zip1"
								:modelValue="form.idZip1"
								:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
								:name="'郵便番号（上３桁）'"
								:groupId="'zipInfo'"
								:maxLength="3"
								@update:modelValue="form.idZip1 = $event"
								ref="idZip1"
								tabindex="12"
							/>&nbsp;-
							<number-input
								class="contents__input--text width-zip2"
								:modelValue="form.idZip2"
								:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
								:name="'郵便番号（下４桁）'"
								:groupId="'zipInfo'"
								:maxLength="4"
								@update:modelValue="form.idZip2 = $event"
								ref="idZip2"
								tabindex="13"
							/>
							<itemerror-message :groupId="'zipInfo'"/>
						</td>
					</tr>
					<tr style="background-color: #fdfdfd">
						<th  class="contents__input--title">
							日本での通称名
						</th>
						<td  class="contents__input--label">
							氏：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmTusyoname1"
								:maxLength="15"
								:textType="TEXTINPUT_TYPE.FULL"
								:name="'氏'"
								:groupId="'tusyomeiInfo'"
								:placeholder="'（フリーワード）'"
								@update:modelValue="form.nmTusyoname1 = $event"
								ref="nmTusyoname1"
								tabindex="5" />
							名：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmTusyoname2"
								:maxLength="15"
								:textType="TEXTINPUT_TYPE.FULL"
								:name="'名'"
								:groupId="'tusyomeiInfo'"
								:placeholder="'（フリーワード）'"
								@update:modelValue="form.nmTusyoname2 = $event"
								ref="nmTusyoname2"
								tabindex="6" />
							<itemerror-message :groupId="'tusyomeiInfo'"/>
						</td>
						<th  class="contents__input--title" >現住所<br/>
						</th>
						<td  class="contents__input--label">
							<text-input
								class="contents__input--text width-txNowadr1"
								:modelValue="form.txNowadr1"
								:maxLength="20"
								:textType="TEXTINPUT_TYPE.FULL"
								:name="'現住所'"
								:groupId="'jusyoInfo'"
								:placeholder="'（フリーワード）'"
								@update:modelValue="form.txNowadr1 = $event"
								ref="txNowadr1"
								tabindex="14" 
							/>
							<itemerror-message :groupId="'jusyoInfo'"/>
						</td>
					</tr>
					<tr>
						<th  class="contents__input--title">
							フリガナ
						</th>
						<td  class="contents__input--label">
							氏：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmTusyokana1"
								:maxLength="30"
								:textType="TEXTINPUT_TYPE.HALF_KANA"
								:name="'フリガナ（氏）'"
								:groupId="'tusyomeiFuriInfo'"
								:placeholder="'(ﾌﾘｰﾜｰﾄﾞ)'"
								@update:modelValue="form.nmTusyokana1 = $event"
								ref="nmTusyokana1"
								tabindex="7" />
							名：
							<text-input
								class="contents__input--text width-nmName"
								:modelValue="form.nmTusyokana2"
								:maxLength="30"
								:textType="TEXTINPUT_TYPE.HALF_KANA"
								:name="'フリガナ（名）'"
								:groupId="'tusyomeiFuriInfo'"
								:placeholder="'(ﾌﾘｰﾜｰﾄﾞ)'"
								@update:modelValue="form.nmTusyokana2 = $event"
								ref="nmTusyokana2"
								tabindex="8" />
							<itemerror-message :groupId="'tusyomeiFuriInfo'"/>
						</td>
						<th  class="contents__input--title">電話番号</th>
						<td  class="contents__input--label">
							<number-input
								class="contents__input--text width-idTel"
								:modelValue="form.idTel1"
								:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
								:name="'電話番号（市外）'"
								:groupId="'telInfo'"
								:maxLength="5"
								@update:modelValue="form.idTel1 = $event"
								ref="idTel1"
								tabindex="15"
							/>&nbsp;-
							<number-input
								class="contents__input--text width-idTel"
								:modelValue="form.idTel2"
								:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
								:name="'電話番号（市内）'"
								:groupId="'telInfo'"
								:maxLength="4"
								@update:modelValue="form.idTel2 = $event"
								ref="idTel2"
								tabindex="16"
							/>&nbsp;-
							<number-input
								class="contents__input--text width-idTel"
								:modelValue="form.idTel3"
								:numberType="NUMBERINPUT_TYPE.NON_PERIOD"
								:name="'電話番号（局番）'"
								:groupId="'telInfo'"
								:maxLength="4"
								@update:modelValue="form.idTel3 = $event"
								ref="idTel3"
								tabindex="17"
							/>
							<itemerror-message :groupId="'telInfo'"/>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="contents__div--center">
				<input type="button" value="検索" class="contents__btn--normal" @click="clickSearchBtn" tabindex="18" />
			</div>
			<hr>
		</section>
		<div v-if="disp.hyojiMeisaiList.length != 0">
			<!-- <h2 class="contents__h2">利用者情報一覧</h2> -->
			<pagination
					:name="'ページヘッダー'"
					:headerTitle="'利用者情報一覧'"
					:class="'margin__bottom-3'"
					:listCount="disp.shutokuMeisaiList.length"
					:displaySortFlg="false"
					:tabindex="19"
					:clickPageSwitch="clickPageSwitchBtn"
					ref="pageHeader" />
			<div align="center">
				<table border="1" id="list" class="contents__table--itiran">
					<thead>
						<tr id="listheader">
							<th id="meisaititle1">No</th>
							<th id="meisaititle2"><div id="meisai-margin">ﾛｯｸ</div><div>状況</div></th>
							<th id="meisaititle3"><div id="meisai-margin">フリガナ</div><div>利用者</div></th>
							<th id="meisaititle4"><div id="meisai-margin">フリガナ</div><div>日本での通称名</div></th>
							<th id="meisaititle5">生年月日</th>
							<th id="meisaititle6">郵便番号</th>
							<th id="meisaititle7">現住所</th>
							<th id="meisaititle8">電話番号</th>
						</tr>
					</thead>
					<tbody>
						<tr id="meisaienen" v-on:click="clickMeisai(row)"  v-for="row in disp.hyojiMeisaiList" :key="row.idRiyosya">
							<td id="meisaino">{{ row.num }}</td>
							<td id="meisailock"><span class="span-fontStyle">{{ row.enabled }}</span></td>
							<td id="meisai_padding"><div id="meisai-margin">{{ row.nmKana1 }}&nbsp;{{ row.nmKana2 }}</div><div>{{ row.nmName }}</div></td>
							<td id="meisai_padding"><div id="meisai-margin">{{ row.nmTusyokana1 }}&nbsp;{{ row.nmTusyokana2 }}</div><div>{{ row.nmTusyoname }}</div></td>
							<td id="meisai_padding-left">{{ co_editDateSlash(row.dtBirthday) }}</td>
							<td id="meisai_padding-left">{{ row.idZip }}</td>
							<td id="meisai_padding-left">{{ row.txNowadr1 }}</td>
							<td id="meisai_padding-left">{{ row.idTel }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<pagination
				:name="'ページフッター'"
				:class="'margin__top-10'"
				:listCount="disp.shutokuMeisaiList.length"
				:displaySortFlg="false"
				:displayFotterFlg="true"
				:tabindex="120"
				:clickPageSwitch="clickPageSwitchBtn"
				ref="pageFotter" />
			<br />
			<br />
		</div>
	</div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import TextInput from '@/components/TextInput.vue';
import NumberInput from '@/components/NumberInput.vue';
import Pagination from '@/components/Pagination.vue';
import ListBox from '@/components/ListBox.vue';
import ItemErrorMessage from '@/components/ItemErrorMessage.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_editDateSlash } from '@/common/stringUtility.js';
import { co_toTop, co_toTrans } from '@/common/screenUtility.js';

import { NUMBERINPUT_TYPE, TEXTINPUT_TYPE } from '@/const/const.js';
import { STORE_VIEW_PROGRESS, STORE_ERROR_CLEAR, STORE_DATA_ADD_DATA, STORE_DATA_GETDATA,
			STORE_ERROR_SETMSG, STORE_ENV_GET_LIST_MAX_COUNT, STORE_ERROR_IS_ERRFLG, STORE_VIEW_CLEAR_PAGE } from '@/const/store.js';
import { PATH_BC015_SEARCH } from '@/const/route.js';

export default {
	name: "BC015",
	components: {
		'error-message': ErrorMessage,
		'text-input': TextInput,
		'number-input': NumberInput,
		'pagination': Pagination,
		'list-box': ListBox,
		'itemerror-message': ItemErrorMessage,
	},
	props: {
		groupId: {type: String, default: ''},					// 項目グループID
	},
	data: function () {
		return {
			
			form: {
				nmName1: '',			// 利用者氏名（氏）
				nmName2: '',			// 利用者氏名（名）
				nmName: '',				// 利用者氏名
				nmKana1: '',			// フリガナ（氏）
				nmKana2: '',			// フリガナ（名）
				nmTusyoname1: '',		// 通称名（氏）
				nmTusyoname2: '',		// 通称名（名）
				nmTusyokana1: '',		// 通称フリガナ（氏）
				nmTusyokana2: '',		// 通称フリガナ（名）
				yrBirthday: '',			// 生年月日（年）
				mtBirthday: '',			// 生年月日（月）
				dyBirthday: '',			// 生年月日（日）
				dtBirthday: '',			// 生年月日
				idZip1: '',				// 郵便番号１
				idZip2: '',				// 郵便番号２
				txNowadr1: '',			// 現住所
				idTel1: '',				// 電話番号（市外）
				idTel2: '',				// 電話番号（市内）
				idTel3: '',				// 電話番号（局番）
				idMailaddress: '',
			},
			disp: {
				yearItems: [], 
				monthItems: [], 
				dayItems: [], 
				hyojiMeisaiList:[],			// 利用者一覧リスト(表示用）
				shutokuMeisaiList:[],		// 取得した利用者一覧リスト
			},
			co_editDateSlash: co_editDateSlash,
			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			TEXTINPUT_TYPE: TEXTINPUT_TYPE,
		};
	},
	mounted: async function () {
		await this.$nextTick();

		// フォーカス設定
		this.$refs.nmName1.focus();
	},
	created: async function() {

		// 生年月日リスト作成
		this.createYearList();
		this.createMonthList();
		this.createDayList();

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 前回の検索条件確認
		let data = this.$store.getters[STORE_DATA_GETDATA]('BC015');
		if (data != null) {

			// 前回情報を画面に設定
			this.form = data;

			// 利用者一覧情報取得
			let list = await co_post(PATH_BC015_SEARCH, data);
			let maxCount = this.$store.getters[STORE_ENV_GET_LIST_MAX_COUNT];

			// 取得件数が０件の場合
			if (list.riyosyaListBC015.length == null || list.riyosyaListBC015.length == 0 ) {

				// エラーメッセージ：E0049を表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0049'));

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
				return;

			// 取得件数が最大件数を超えた場合
			} else if (list.riyosyaListBC015.length > maxCount) {
				// エラーメッセージ：E0048を表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0048', maxCount));
				
				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
				return;
			}

			// 利用者一覧情報を一覧に設定
			this.disp.hyojiMeisaiList = list.riyosyaListBC015;
			this.disp.shutokuMeisaiList = this.disp.hyojiMeisaiList;
		}

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	methods: {
		// 年リスト作成
		createYearList: function () {

			let startYear = 1900;
			let endYear = (new Date()).getFullYear();

			// 年リスト設定
			let yearItemsList = [];
			yearItemsList.push({idCd : '', nmCd : '----'});

			for (let i = startYear-1; i < endYear; i++) {
					yearItemsList.push({
										idCd : i + 1, nmCd : i + 1
										});
			}
			this.disp.yearItems = yearItemsList;

		},
		// 月リスト作成
		createMonthList: function () {

			// 月リスト設定
			let monthItemsList = [];
			monthItemsList.push({idCd : '', nmCd : '--'});
			for (let i = 0; i < 12; i++) {
					monthItemsList.push({
										idCd : this.zeroPadding(i + 1, 2), nmCd : this.zeroPadding(i + 1, 2)
										});
			}
			this.disp.monthItems = monthItemsList;

		},
		// 日リスト作成
		createDayList: function () {

			// 日リスト設定
			let dayItemsList = [];
			dayItemsList.push({idCd : '', nmCd : '--'});
			for (let i = 0; i < 31; i++) {
					dayItemsList.push({
										idCd : this.zeroPadding(i + 1, 2), nmCd : this.zeroPadding(i + 1, 2)
										});
			}
			this.disp.dayItems = dayItemsList;

		},
		// ゼロ埋め
		zeroPadding: function(num, len) {
			return ( Array(len).join('0') + num ).slice( -len );
		},


		// 検索ボタン押下
		clickSearchBtn: async function() {

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 全角・半角を変換
			this.$refs.nmName1.validate();
			this.$refs.nmName2.validate();
			this.$refs.nmKana1.validate();
			this.$refs.nmKana2.validate();
			this.$refs.idZip1.validate();
			this.$refs.idZip2.validate();
			this.$refs.nmTusyoname1.validate();
			this.$refs.nmTusyoname2.validate();
			this.$refs.txNowadr1.validate();
			this.$refs.nmTusyokana1.validate();
			this.$refs.nmTusyokana2.validate();
			this.$refs.idTel1.validate();
			this.$refs.idTel2.validate();
			this.$refs.idTel3.validate();

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				return;
			}

			// 明細を初期化
			this.disp.hyojiMeisaiList = [];
			this.$store.commit(STORE_VIEW_CLEAR_PAGE);

			// 利用者一覧情報取得
			let data = await co_post(PATH_BC015_SEARCH, this.form);
			let maxCount = this.$store.getters[STORE_ENV_GET_LIST_MAX_COUNT];

			// 取得件数が０件の場合
			if (data.riyosyaListBC015.length == null || data.riyosyaListBC015.length == 0) {
				// エラーメッセージ：E0049を表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0049'));

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
				return;

			// 取得件数が最大件数を超えた場合
			} else if (data.riyosyaListBC015.length > maxCount) {
				// エラーメッセージ：E0048を表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0048', maxCount));
				
				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);
				return;
			}

			// 利用者一覧情報を一覧に設定
			this.disp.hyojiMeisaiList = data.riyosyaListBC015;
			this.disp.shutokuMeisaiList = this.disp.hyojiMeisaiList;

			// 入力値保持
			this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC015', data: this.form });

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

		},
		// 明細押下
		clickMeisai: function (row) {

			// 利用者情報画面に遷移
			let params = { enabled : row.enabled, idRiyosya : row.idRiyosya };
			co_toTrans('BC016', params);
		},
		// ページ切替ボタン押下処理
		clickPageSwitchBtn: function (startIndex, endIndex) {

			let eitMeisaiList = [];
			for (let i = startIndex; i < endIndex; i++) {
				eitMeisaiList.push(this.disp.shutokuMeisaiList[i]);
			}
			this.disp.hyojiMeisaiList = eitMeisaiList;

			// ページトップへ遷移
			co_toTop();
		},
	}
}
</script>

<style scoped>

@media all and (-ms-high-contrast: none) {
    .ichiran th:nth-child(1) {
        width: 8% !important;
    }
	.ichiran td:nth-child(2) {
	width: 41% !important;
	}

	.ichiran th:nth-child(3) {
		width: 8% !important;
	}

	.ichiran td:nth-child(4) {
		width: 41% !important;
	}
}

.contents__main{
	margin-left: 1% !important;
	margin-right: 1% !important;
}
.contents__table--ichiran{
	width: 100%;
	table-layout: fixed;
}
.contents__table--ichiran th,
.contents__table--ichiran td {
	line-height: 2em;
	vertical-align: top;
	padding: 10px 10px 10px;
	position: relative; 
}
.ichiran th:nth-child(1) {
	width: 7%;
}

.ichiran td:nth-child(2) {
	width: 42%;
}

.ichiran th:nth-child(3) {
	width: 7%;
}

.ichiran td:nth-child(4) {
	width: 42%;
}
.width-nmName {
	width: 36%;
}
.width-zip1 {
	text-align: left;
	width: 20%;
}
.width-zip2 {
	text-align: left;
	width: 24%;
}
.width-txNowadr1 {
	width: 91%;
}
.width-idTel {
	width: 21%;
	text-align: left;
}
#meisaititle1{
	width: 4%;
	padding-top: 28px;
	padding-bottom: 28px;
}
#meisaititle2{
	width: 4%;
}
#meisaititle3{
	width: 18%;
}
#meisaititle4{
	width: 18%;
}
#meisaititle5{
	width: 12%;
}
#meisaititle6{
	width: 10%;
}
#meisaititle7{
	width: 20%;
}
#meisaititle8{
	width: 14%;
}
#list{
	width: 100%;
}
#list tbody tr:nth-child(even) td, #list tbody tr:nth-child(even) th {
    background-color: #eeeeee;
}
#list tbody tr:hover td, #list tbody tr:hover th {
    background-color: #fff5d5;
}
#meisai_padding{
	padding-left: 8px;
	padding-top: 15px;
	padding-bottom: 14px;
}
#meisai_padding-left{
	padding-left: 8px;
}
#meisai-margin{
	margin-bottom: 5px;
}
#meisailock{
	padding-left: 8px;
	padding-right: 2px;
}
#meisaino{
	text-align: right;
	padding-right: 2px;
}
.span-fontStyle {
	color: #FF0000;
	font-weight: bold;
}
</style>
